module.exports = __webpack_public_path__ + "img/plus-white.95e860ce.svg";